import moment from "moment";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { INotification } from "../../../models/notification.model";
import { RootState } from "../../../store/rootReducer";
import { getCommonCodeLabel } from "../../../lib/store";

interface IProps {
  data: INotification|undefined;
  className?: string|undefined;
}

const NoticeViewer: FC<IProps> = ({
  data,
  className,
}) => {
  const { t, i18n } = useTranslation();
  const { chosenClass } = useSelector((state: RootState) => state.class);

  return (
    <div className='comm-table__area rowType edit mt-0'>
      <table>
        <colgroup>
          <col width="150px" />
          <col width="200px" />
          <col width="*" />
          <col width="*" />
        </colgroup>
        <tbody>
          <tr>
            <th className="text-center">{t('class.class.column89')}</th>
            <td>
              {moment(data?.timetableDate).format('YYYY.MM.DD')}
            </td>
            <th className="text-center">{t('class.class.column87')}</th>
            <td>
              {getCommonCodeLabel('PR0006', data?.eduStepCode || '', i18n.language)}
            </td>
          </tr>
          <tr>
            <th className="text-center">{t('class.class.column57')}</th>
            <td colSpan={3}>
              {className ? className : chosenClass?.className}
            </td>
          </tr>
          <tr>
            <th className="text-center">{t('statistics.homework.column4')}</th>
            <td>
              {getCommonCodeLabel('NT0001', data?.noticeType || '', i18n.language)}
            </td>
            <th className="text-center w-150p">{t('class.class.column90')}</th>
            <td>
              {data?.noticeType === 'HW' ? t('class.class.text29') + data?.classTimeSeq + t('class.class.text30') + '(' + data?.subjectName + ')' : '-'}
            </td>
          </tr>
          <tr>
            <th className="text-center">
              {t('class.class.column91')}
            </th>
            <td className="text-left" colSpan={3}>
              {data?.title}
            </td>
          </tr>
          <tr>
            <th className="text-center">{t('class.class.column92')}</th>
            <td colSpan={3}>
              <div
                dangerouslySetInnerHTML={{ __html: data?.content || '' }}
                style={{ whiteSpace: 'pre-wrap' }}                
              />
            </td>
          </tr>
          <tr>
            <th className="text-center">{t('class.notice.duedate')}</th>
            <td colSpan={3}>{ (data?.dueDate) ? moment(data?.dueDate).format('YYYY.MM.DD') : '-'}</td>
          </tr>
          <tr>
            <th className="text-center">{t('archive.exam.column7')}</th>
            <td colSpan={3}>
              {
                data?.files
                  ? data?.files.map(item => (
                    <a
                      className="download-link mr-1"
                      href={item.fileLocation}
                      download={item.originalName}
                    >
                      {item.originalName}
                    </a>
                  ))
                  : '-'
              }
            </td>
          </tr>
          <tr>
            <th className="text-center">{t('class.class.column94')}</th>
            <td className="pl-4">
              {data ? data.alarmYN === 'Y' ? t('common.option.yes') : t('common.option.no') : ''}
            </td>
            <th className="text-center">{t('class.class.column95')}</th>
            <td>
              {data ? (data.alarmYN === 'N' ? '-' : (data.onlySmsYn === 'Y' ? t('class.class.option5') : t('class.class.option4'))) : ''}
            </td>
          </tr>
          <tr>
            <th className="text-center">{t('class.class.column93')}</th>
            <td colSpan={3}>{data?.writerMemberName}</td>
          </tr>
          {data?.resvYn === 'Y' &&
            <tr>
              <th className="text-center">{t('class.notice.label2')}</th>
              <td colSpan={3}>
                {t('class.notice.label4')} ({(data?.resvDateTime)?moment(data?.resvDateTime).format('YYYY.MM.DD HH:mm'):''})<br/>
                <span className="notice-high">{t('class.notice.message8')}</span>
              </td>
            </tr>
          }
          
        </tbody>
      </table>
    </div>
  );
}

export default NoticeViewer;
